
import CSV_Icon from 'images/csv.png';
import XLSX_Icon from 'images/xlsx.png'
import Image_Placeholder from 'images/image_placeholder.png';
import PlaceHolder_Icon from 'images/placeholder.jpg';
import PDF_Icon from 'images/pdf_placeholder.png';

export const renderFilePreview = (filename) => {
if (typeof filename === 'undefined' || !filename) {
    return null; // Or return a fallback UI if needed
    }
  let icon;

  if (filename.includes('.xlsx')) {
    icon = XLSX_Icon;
  } else if (filename.includes('.csv')) {
    icon = CSV_Icon;
  } else if (filename.includes('jpg')) {
    icon = Image_Placeholder; // Placeholder for images
  } else if (filename.includes('jpeg')) {
    icon = Image_Placeholder; // Placeholder for images
  } else if (filename.includes('png')) {
    icon = Image_Placeholder; // Placeholder for images
  } else if (filename.includes('.pdf')) {
    icon = PDF_Icon; // Placeholder for PDFs
  } else {
    icon = PlaceHolder_Icon; // Optional: a default placeholder for unsupported types
  }

  return <img src={icon} width="40" height="40" alt="file preview" />;
};